<template>
    <div class="login-page">
        <div class="login-page__panel">
            <div class="login-page__title">{{ appearance.title }}</div>
            <div class="login-page__subtitle">{{ appearance.subtitle }}</div>

            <el-form
                ref="loginForm"
                :model="form"
                :rules="rules"
                label-position="top"
                @submit.native.prevent="handleSubmit"
            >
                <el-form-item label="用户名" prop="username">
                    <el-input v-model.trim="form.username" placeholder="请输入用户名" />
                </el-form-item>

                <el-form-item label="密码" prop="password">
                    <el-input
                        v-model="form.password"
                        type="password"
                        show-password
                        placeholder="请输入密码"
                        @keyup.enter.native="handleSubmit"
                    />
                </el-form-item>

                <el-alert
                    v-if="errorMessage"
                    :title="errorMessage"
                    type="error"
                    :closable="false"
                    class="login-page__alert"
                />

                <el-button
                    type="primary"
                    :loading="loading"
                    class="login-page__button"
                    @click="handleSubmit"
                >
                    {{ appearance.buttonLabel }}
                </el-button>
            </el-form>

            <div v-if="appearance.footerHint" class="login-page__hint">
                {{ appearance.footerHint }}
            </div>
        </div>
    </div>
</template>

<script>
var LOGIN_APPEARANCE_DEFAULTS = {
    title: '今兔执照注销全流程管理系统',
    subtitle: '请输入账号密码登录后台',
    buttonLabel: '登录系统',
    footerHint: '演示账号：`admin` / `admin123456`'
};

export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            errorMessage: '',
            appearance: Object.assign({}, LOGIN_APPEARANCE_DEFAULTS),
            form: {
                username: 'admin',
                password: 'admin123456'
            },
            rules: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '密码长度至少 6 位', trigger: 'blur' }
                ]
            }
        };
    },
    created() {
        this.loadLoginAppearance();
    },
    methods: {
        loadLoginAppearance() {
            var _this = this;
            var defaults = LOGIN_APPEARANCE_DEFAULTS;

            window.axios.get('/public/login-appearance').then(function (response) {
                var d = response.data && response.data.data ? response.data.data : {};
                var fh = d.footer_hint;
                var footerHint;
                if (fh === null || fh === undefined) {
                    footerHint = defaults.footerHint;
                } else if (String(fh).trim() === '') {
                    footerHint = '';
                } else {
                    footerHint = String(fh).trim();
                }
                _this.appearance = {
                    title: (d.title && String(d.title).trim()) ? String(d.title).trim() : defaults.title,
                    subtitle: (d.subtitle && String(d.subtitle).trim()) ? String(d.subtitle).trim() : defaults.subtitle,
                    buttonLabel: (d.button_label && String(d.button_label).trim()) ? String(d.button_label).trim() : defaults.buttonLabel,
                    footerHint: footerHint
                };
                if (typeof document !== 'undefined') {
                    document.title = _this.appearance.title;
                }
            }).catch(function () {
                _this.appearance = Object.assign({}, defaults);
                if (typeof document !== 'undefined') {
                    document.title = defaults.title;
                }
            });
        },
        handleSubmit() {
            var _this = this;

            this.$refs.loginForm.validate(function (valid) {
                if (!valid) {
                    return false;
                }

                _this.loading = true;
                _this.errorMessage = '';

                _this.$store.dispatch('login', _this.form).then(function (response) {
                    _this.$message.success('登录成功');
                    var user = response && response.data && response.data.user ? response.data.user : null;
                    var r = user && user.roles ? user.roles : [];
                    var dest = '/';
                    var dMenu = user && user.dispatch_receiver_menu ? user.dispatch_receiver_menu : null;
                    if (r.indexOf('channel-specialist') >= 0) {
                        dest = '/channels';
                    } else if (r.indexOf('field-specialist') >= 0) {
                        dest = '/field-partners';
                    } else if (dMenu && typeof dMenu.tax_stages === 'boolean' && typeof dMenu.biz_stages === 'boolean') {
                        if (dMenu.tax_stages) {
                            dest = '/todos';
                        } else if (dMenu.biz_stages) {
                            dest = '/tax-cleared';
                        } else {
                            dest = '/dispatch/manage';
                        }
                    }
                    _this.$router.replace(dest);
                }).catch(function (error) {
                    _this.errorMessage = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '登录失败，请稍后重试';
                }).finally(function () {
                    _this.loading = false;
                });
            });
        }
    }
};
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #409eff, #67c23a);
}

.login-page__panel {
    width: 420px;
    padding: 32px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.login-page__title {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
}

.login-page__subtitle {
    margin-top: 8px;
    margin-bottom: 24px;
    color: #909399;
}

.login-page__button {
    width: 100%;
}

.login-page__alert {
    margin-bottom: 16px;
}

.login-page__hint {
    margin-top: 16px;
    color: #909399;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Login.vue